import React from 'react';
import Icon from '../../../components/AppIcon';

const ImpactStatsCard = ({ icon, title, value, unit, equivalency, color = 'var(--color-primary)' }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-warm transition-smooth">
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${color}15` }}>
          <Icon name={icon} size={24} color={color} />
        </div>
        <div>
          <h3 className="font-heading font-semibold text-foreground">{title}</h3>
          <p className="text-sm text-muted-foreground">{equivalency}</p>
        </div>
      </div>
      
      <div className="space-y-2">
        <div className="flex items-baseline space-x-2">
          <span className="text-3xl font-bold text-foreground">{value}</span>
          <span className="text-lg text-muted-foreground">{unit}</span>
        </div>
      </div>
    </div>
  );
};

export default ImpactStatsCard;